const PageNotFound = () => {
    return (
        <div/>
    )
}

export default PageNotFound;